<template>
  <v-col class="vuse-content-wrapper">
    <vuse-section-definition
        :breadcrumbs="breadcrumbs"
        :title="page"
        icon="mdi-poll"
    ></vuse-section-definition>
    <v-container class=" p-5" fluid>
      <v-row class="mr-4">
        <v-col class="white rounded-lg" cols="12">
          <v-row>
            <v-col cols="6">
              <v-col cols="12">
                <v-text-field
                    v-model="serviceDetail.name"
                    filled
                    label="Name"
                    placeholder="Enter service name"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-textarea
                    v-model="serviceDetail.description"
                    filled
                    label="Description"
                    placeholder="Enter service description"
                ></v-textarea>
              </v-col>
              <v-col cols="12">
                <v-file-input
                    v-model="image"
                    label="Ảnh"
                    placeholder="Tải ảnh lên"
                    prepend-icon="mdi-camera"
                    @change="uploadImg"
                ></v-file-input>
                <v-img :class="[display_image ? 'mb-8':'d-none']"
                       :src="display_image? display_image :''" aspect-ratio="1.7" width="50"
                       contain
                ></v-img>
              </v-col>
            </v-col>
            <v-col cols="6">
              <v-col cols="12">
                <v-text-field
                    v-model="serviceDetail.name_vi"
                    filled
                    label="Tên"
                    placeholder="Nhập tên service"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-textarea
                    v-model="serviceDetail.description_vi"
                    filled
                    label="Mô tả"
                    placeholder="Nhập mô tả service"
                ></v-textarea>
              </v-col>
            </v-col>
          </v-row>
          <v-col cols="12" class="text-center">
            <v-btn
                color="primary"
                width="180"
                @click="save()"
            >
              Lưu
            </v-btn>
          </v-col>
        </v-col>
      </v-row>
    </v-container>
  </v-col>
</template>

<script>
import {mapGetters} from "vuex";
import {UPLOAD_IMAGE} from "@/store/modules/field_project";
import {GET_DETAIL_SERVICE, UPDATE_SERVICE} from "@/store/modules/service";

export default {
  name: "Edit_service",
  data() {
    return {
      page: "Sửa service ",
      breadcrumbs: [
        {
          text: "Trang chủ",
          disabled: true,
        },
        {
          text: "Danh sách service",
          disabled: true,
        },
        {
          text: "Sửa",
          disabled: false,
        },
      ],

      image: null,
      display_image: '',
      url: '',

    }
  },
  computed: {
    ...mapGetters({
      serviceDetail: "serviceDetail",
    }),
  },
  async created() {
    this.url = process.env.VUE_APP_API_URL
    await this.$store.dispatch(GET_DETAIL_SERVICE, this.$route.params.id);
  },
  watch: {
    serviceDetail(val) {
      if (val && val.photo_url) {
        this.display_image = this.url + val.photo_url;
      }
    }
  },
  methods: {
    uploadImg(e) {
      if (!e) {
        this.display_image = "";
        this.serviceDetail.photo_url = "";
      }
      this.display_image = URL.createObjectURL(e)
      this.$forceUpdate()
    },

    async save() {
      if (this.image != null) {
        let formDateAvatar = new FormData();
        formDateAvatar.append("upload", this.image);
        formDateAvatar.append("type", "ckeditor");
        formDateAvatar.append("position_type", "1");
        await this.$store.dispatch(`${UPLOAD_IMAGE}`, formDateAvatar).then((data) => {
              if (data.data.status == 1) {
                this.serviceDetail.photo_url = data.data.data[0].path
              }
            }
        )
      }
      await this.$store.dispatch(`${UPDATE_SERVICE}`, this.serviceDetail).then((data) => {
        if (data.data.status == 1) {
          this.$toasted.success('Cập nhật thành công!', {
            duration: 1000,
            position: 'top-center'
          })
          this.$router.push('/service')
        } else {
          alert(data.data.errors)
        }
      });
    }
  }
}
</script>

<style scoped>

</style>